import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { AbsencePeriod } from './AbsencePeriod';
import { InstitutionMember } from './InstitutionMember';
import { User } from './User';

export interface AbsencePeriodUserRow {
  id: number;
  absence_period_id: number;
  institution_member_id: number;
  user_id: string;
  rag_status: string;
  absence_count: number;
  attended_count: number;
  not_occurred_event_count: number;
  tracked_event_count: number;
  booking_count: number;
}

export const AbsencePeriodUser: Entity<AbsencePeriodUserRow> = {
  id: 'AbsencePeriodUser',
  title: 'Absence Period User',
  service: 'main',
  rowLabel: (row: AbsencePeriodUserRow) => `User ${row.user_id} - ${row.rag_status}`,
  rowLabelDynamic: (row: AbsencePeriodUserRow) =>
    `<lookup:User:${row.user_id}> - <lookup:AbsencePeriod:${row.absence_period_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.absence_period_user',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition:
        'absence_period_id IN ( SELECT id FROM public.absence_period WHERE institution_id = {adminInstitutionId} )',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [
    ['rag_status', 'DESC'],
    ['absence_count', 'DESC'],
  ],
  listRowLink: '/admin/absence-period-user/display/{key}',
  fields: {
    id: {
      seq: 10,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
      listColumn: true,
    },
    absence_period_id: {
      seq: 20,
      label: 'Absence Period',
      type: FieldType.Reference,
      refEntity: AbsencePeriod,
      mandatory: true,
      listColumn: true,
    },
    institution_member_id: {
      seq: 30,
      label: 'Institution Member',
      type: FieldType.Reference,
      refEntity: InstitutionMember,
      mandatory: true,
      listColumn: true,
    },
    user_id: {
      seq: 35,
      label: 'User',
      type: FieldType.Reference,
      refEntity: User,
      mandatory: true,
      listColumn: true,
    },
    rag_status: {
      seq: 40,
      label: 'RAG Status',
      type: FieldType.Options,
      mandatory: true,
      listColumn: true,
      options: [
        { id: 'green', label: 'Green' },
        { id: 'amber', label: 'Amber' },
        { id: 'red', label: 'Red' },
      ],
    },
    absence_count: {
      seq: 50,
      label: 'Absence Count',
      type: FieldType.Integer,
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
      description: 'Number of absences for this user in this period',
    },
    attended_count: {
      seq: 55,
      label: 'Attended Count',
      type: FieldType.Integer,
      persistence: PersistenceType.BackEndManaged,
      description: 'Number of attended events for this user in this period',
    },
    not_occurred_event_count: {
      seq: 57,
      label: 'Not Occurred Event Count',
      type: FieldType.Integer,
      persistence: PersistenceType.BackEndManaged,
      description: 'Number of not occurred events for this user in this period',
    },
    tracked_event_count: {
      seq: 60,
      label: 'Tracked Event Count',
      type: FieldType.Integer,
      persistence: PersistenceType.BackEndManaged,
      description: 'Number of tracked events for this user in this period',
    },
    booking_count: {
      seq: 70,
      label: 'Booking Count',
      type: FieldType.Integer,
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
      description: 'Number of bookings for this user in this period',
    },
  },
};
